<script setup>
import {Head, Link, useForm} from '@inertiajs/vue3';
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import JetButton from '@/Jetstream/Button.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetValidationErrors from '@/Jetstream/ValidationErrors.vue';

defineProps({
  canResetPassword: Boolean,
  status: String,
});

const form = useForm({
  email: '',
  password: '',
  remember: false,
});

const submit = () => {
  form.transform(data => ({
    ...data,
    remember: form.remember ? 'on' : '',
  })).post(route('login'), {
    onFinish: () => form.reset('password'),
  });
};

</script>

<template>
  <Head :title="$t('Login')"/>

  <JetAuthenticationCard>
    <template #logo>
      <JetAuthenticationCardLogo/>
      <h3 class="mt-10 text-3xl font-extrabold text-primary-500">{{ $t('Login') }}</h3>
    </template>

    <JetValidationErrors class="mb-4"/>

    <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
      {{ status }}
    </div>

    <form @submit.prevent="submit">
      <div>
        <JetLabel for="email" :value="$t('Email')"/>
        <JetInput
            id="email"
            v-model="form.email"
            type="email"
            class="mt-1 block w-full"
            required
            autofocus
        />
      </div>

      <div class="mt-4">
        <JetLabel for="password" :value="$t('Password')"/>
        <JetInput
            id="password"
            v-model="form.password"
            type="password"
            class="mt-1 block w-full"
            required
            autocomplete="current-password"
        />
      </div>

      <div class="flex flex-col items-start mt-4">
        <JetButton class="mb-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
          {{ $t('Login') }}
        </JetButton>

        <Link v-if="canResetPassword" :href="route('password.request')"
              class="underline text-sm text-gray-600 hover:text-gray-900">
          {{ $t('Forgot your password?') }}
        </Link>
      </div>
    </form>

  </JetAuthenticationCard>
</template>
